import React, {Fragment} from "react";

import {SortableContainer, SortableElement, SortableHandle} from "react-sortable-hoc";
import Format from 'utils/format'
import styled from "styled-components";
import {allUnits} from 'utils/actions';
import {i18n} from "../../translate/i18n";
import {SelectPrincipalUnit, SelectUnit} from "../Select";
import {useUser} from "../../store/providers/app";

export const UnitOptions = ({option}) => {
    return (
        <Fragment>
            { allUnits.map((item, index) =>
                <option key={index} value={item.value} selected={option === item.value}>{item.label}</option>
            )}
        </Fragment>

    )
}


export const SortableCont = SortableContainer(({children}) => {
    return <tbody>{children}</tbody>;
});

const arrayMoveMutate = (array, from, to) => {
    array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
};

export const arrayMove = (array, from, to) => {
    array = array.slice();
    arrayMoveMutate(array, from, to);
    return array;
};

const Handle = styled.div`
  cursor: grab;
`;

const TrWrapper = styled.tr`
  cursor: default;

  .firstElement {
    display: flex;
    flex-direction: row;
  }

  &.helperContainerClass {
    width: auto;
    border: 1px solid #efefef;
    box-shadow: 0 5px 5px -5px rgba(0, 0, 0, 0.2);
    background-color: #f7f7f7;
    border-radius: 3px;
    z-index: 99999;
    
    & > td {
      padding-left: 20px;
      text-align: left;
      width: 200px;
    }
  }
`;

const TableRow = ({row, rowPosition, newRows, editInputRow, deleteTableRows, formatRow, status}) => {

    return (
        <TrWrapper>
            <td  style={{width: "10px"}}>
                <div className="firstElement">
                    <RowHandler/>
                </div>
            </td>

            {row.map((item, position) =>
            {
                let block = "0";

                if (item?.block_column === "1") {
                    block = "1";
                }

                return ( <td key={position} className="p-1">
                    <div className="input-group">

                        <Format
                            value={item.value}
                            unit={item.unit}
                            editInputRow={editInputRow}
                            rowPosition={rowPosition}
                            position={position}
                            displayType={block === "1" && 'text'}
                        />

                        {block === "0" && status !== 'finished' &&
                            <span className="input-group-text bg-white border-0">
                            <div className="btn-group btn-group-sm dropdown">
                                <button type="button"
                                        className="btn border-0 rounded-0 bi-search p-0 bi-three-dots-vertical"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true" data-bs-auto-close="false" aria-expanded="false"/>

                                <ul className="dropdown-menu  dropdown-menu-custom shadow-sm p-3">
                                    <div className="form-group">
                                        <label className="form-label">{i18n.t('label.unit')}</label>
                                        <SelectPrincipalUnit unit={item.unit} onChangeUnits={formatRow}
                                                             position={position} rowPosition={rowPosition}/>
                                    </div>
                                </ul>
                            </div>
                        </span>
                        }
                    </div>
                </td>);
            }


            )}

            { status !== 'finished' &&
                <td className="p-0 text-center bg-light">
                    {newRows.length > 1 &&
                        <span className="text-danger bi-x-circle-fill" role="button"
                              onClick={() => deleteTableRows(rowPosition)}/>
                    }
                </td>
            }
        </TrWrapper>
    );
};

export const SortableItem = SortableElement(props => <TableRow {...props} />);

export const RowHandler = SortableHandle(() => <Handle className="handle bi-view-list"/>);


